<div class="creativity-container font-inter">
    <div class="creativity-content container">
        <div class="left-section">
            <p class="creativity-title font-poppins">Shape Your Imagination into a Timeless Experience</p>
            <p class="creativity-subtitle">
                Not just for children, not just a toy - where imagination leads, not instructions. Where colors carry
                emotion. Where shapes tell stories. Where patterns become personal.
            </p>

            <div class="section">
                <div>
                    <div class="icon-container primary">
                        <mat-icon [svgIcon]="'tick'" class="quality-icon"></mat-icon>
                    </div>
                </div>
                <div>
                    <p class="section-title font-poppins">For Every Age</p>
                    <p class="section-subtitle">
                        Designed for hands of all sizes and minds of all ages - bringing generations together through
                        play.
                    </p>
                </div>
            </div>
            <div class="section font-poppins">
                <div>
                    <div class="icon-container secondary">
                        <mat-icon [svgIcon]="'tick'" class="quality-icon"></mat-icon>
                    </div>
                </div>
                <div>
                    <p class="section-title">Design It Your Way</p>
                    <p class="section-subtitle">
                        Customize colors, shapes, and patterns in our Design Studio to create blocks that are uniquely
                        yours.
                    </p>
                </div>
            </div>
            <div class="section font-poppins">
                <div>
                    <div class="icon-container tertiary">
                        <mat-icon [svgIcon]="'tick'" class="quality-icon"></mat-icon>
                    </div>
                </div>
                <div>
                    <p class="section-title">Emotion - Led Colors</p>
                    <p class="section-subtitle">
                        Thoughtfully balanced hues that inspire imagination, support visual development, and create
                        calm.
                    </p>
                </div>
            </div>
            <div class="section font-poppins">
                <div>
                    <div class="icon-container primary">
                        <mat-icon [svgIcon]="'tick'" class="quality-icon"></mat-icon>
                    </div>
                </div>
                <div>
                    <p class="section-title">Built Without Limits</p>
                    <p class="section-subtitle">
                        Open - ended blocks with no rules or instructions - freeing creativity to grow naturally over
                        time.
                    </p>
                </div>
            </div>

            <button mat-flat-button class="learn-more-btn">Learn More</button>
        </div>

        <div class="right-section">
            <img src="assets/images/imageprorom3.jpg" class="creativity-image" alt="Colorful toy blocks" />
        </div>
    </div>
</div>
